// @flow

import React from 'react';
import {
  CloseButton,
  CloseIcon,
  Heading,
  Wrapper,
} from './atoms';
import withNoScroll from '../withNoScroll';
import type { Props } from './types';
import Overlay from '../overlay';

const DrawerColumn = ({
  title,
  closeText,
  children,
  open,
  toggle,
  position,
  width,
  sticky,
  overlay,
  handleClose,
}: Props) => (
  <>
    {open && overlay && (
      <Overlay
        handleClose={() => handleClose()}
      />
    )}
    <Wrapper
      open={open}
      position={position}
      width={width}
      sticky={sticky}
      overlay={overlay}
      closeText={closeText}
      handleClose={handleClose}
      title={title}
    >
      <Heading>
        {title}
        <CloseButton onClick={toggle}>
          {closeText}
          <CloseIcon />
        </CloseButton>
      </Heading>
      {children}
    </Wrapper>
  </>
);

export default withNoScroll({ breakpoint: 'lg', prop: 'open' })(DrawerColumn);
